<template>
  <div class="container new-box">
    <div class="header clearfix">
      <div class="login-box">
        <span class="nav-sp">
          <img src="../../assets/images/logo1.jpg" alt="">
          <span>四川广智华荣工程项目咨询有限公司</span>
          <em class="em2">Sichuan Guangzhi Huarong Project Consulting Co., Ltd</em>
          <em>规范，专业，服务，创新</em>
        </span>
        <p class="login-iphone2" v-if="user_id==''">
          <span class="iphone-sp0"><em @click="dialogVisible = true">登录</em>/<em @click="goreg()">注册</em></span>
          <span class="iphone-sp1">咨询电话</span>
          <span class="iphone-sp2">028-61894045</span>
        </p>
        <div class="login-user" v-if="user_id!=''">
          <p class="user-p1"><a href="javascript:;" @click="gobsxt()">标书大厅</a><a href="javascript:;"
              @click="gouser()">报名的项目</a><a href="javascript:;">中标项目</a><a href="javascript:;"
              @click="gologinout">退出登录</a></p>
          <p class="user-p2"><a href="javascript:;" @click="goqyxx()">当前账号</a>：{{user_name}}</p>
          <p class="user-p3"><a href="javascript:;">咨询电话</a><a href="javascript:;">投诉建议</a><a
              href="javascript:;">常见问题</a><a href="javascript:;">标书领取</a></p>
        </div>


      </div>
      <div class="nav">
        <p class="nav-p">
          <a href="javascript:;" @click="goHome()"><span>官方首页</span> </a>
          <a href="javascript:;" @click="goqyjj()"><span>企业简介</span> </a>
          <a href="javascript:;" @click="gozbxx()"><span>招标信息</span> </a>
          <a href="javascript:;" @click="gokffw()"><span>客服服务</span></a>
          <a href="javascript:;" @click="gogsdt()"><span>公司动态</span></a>
          <a href="javascript:;" @click="gojlyd()"><span>交流园地</span></a>
          <a href="javascript:;" @click="gorczp()"><span>人才招聘</span></a>
          <a href="javascript:;" @click="gobsxt()"><span>报名系统</span></a>

        </p>
      </div>
    </div>
    <!--switch-->
    <div class="switch3 clearfix">
      <img src="../../assets/images/bssm-ban.jpg" alt="">
      <div class="search">
        <el-input  type="text" v-model="input" placeholder="请输入需要搜索的标书名称或者项目编号"></el-input>
        <el-row>
          <el-button>确认搜索</el-button>
        </el-row>
      </div>
    </div>
    <!--switch END-->
    <!--content -->
    <!--center-->
    <div class="center-bsxt clearfix">
      <div class="bsxt">
        <template v-if="regnumber==0">
          <el-tabs @tab-click="handleClick" v-model="activeName">
            <el-tab-pane label="全部项目" name="first">
              <div class="list-box" v-if="bstype==1">
                <p class="bsxt-p"><span class="span1">采购编号</span><span class="span2">项目名称</span><span
                    class="span3">招标文件领取日期</span></p>
                <ul class="bsxt-ul">
                  <li v-for="(bslistdata,index) in bslistdata" :key="index">
                    <span class="span1">{{bslistdata.project_sn}}</span>
                    <span class="span2" @click="getbstext(bslistdata.documents_id)">{{bslistdata.project_name}}</span>
                    <span class="span3">{{bslistdata.receive}}</span>
                  </li>
                </ul>
                <div class="block">
                  <el-pagination layout="prev, pager, next"   :page-size="15" :total="total"  @current-change="handleSizeChange">
                  </el-pagination>
                </div>
              </div>
              <div class="bstext" v-if="bstype==2">
                <div class="bstext-top">
                  <dl class="dl1">
                    <dd class="dt-h1">{{bstextdata.project_name}}</dd>
                    <dt>采购项目编号</dt>
                    <dd>{{bstextdata.project_sn}}</dd>
                    <dt>分包数</dt>
                    <dd>{{bstextdata.subcontract}}</dd>
                    <dt>项目性质</dt>
                    <dd v-if="bstextdata.project_nature==1">政府采购</dd>
                    <dd v-if="bstextdata.project_nature==2">工程招标</dd>
                    <dd v-if="bstextdata.project_nature==3">企业招标</dd>

                  </dl>
                  <dl>
                    <dt>代理机构</dt>
                    <dd>{{bstextdata.agency}}</dd>
                    <dt>采购方式</dt>
                    <dd v-if="bstextdata.procurement_method==1">公开招标</dd>
                    <dd v-if="bstextdata.procurement_method==2">竞争性磋商</dd>
                    <dd v-if="bstextdata.procurement_method==3">询价</dd>
                    <dd v-if="bstextdata.procurement_method==4">其他</dd>
                    <dt>保证金缴纳截止时间</dt>
                    <dd>{{bstextdata.bond_by_at}}</dd>
                  </dl>
                  <dl>
                    <dt>标书领取时间</dt>
                    <dd class="cd3">{{bstextdata.receive_start_at}}--{{bstextdata.receive_end_at}}</dd>
                    <dt>项目开标时间</dt>
                    <dd>{{bstextdata.opening_at}}</dd>
                  </dl>
                  <dl>
                    <dt>付费方式</dt>
                    <dd v-if="bstextdata.payment_method==1">按项目收费</dd>
                    <dd v-if="bstextdata.payment_method==2">其他</dd>
                    <dt>标书款服务费</dt>
                    <dd>{{bstextdata.tender_service_fee}}元</dd>
                    <dd class="cd4"></dd>
                  </dl>
                  <dl class="dl3">
                    <dt>备注</dt>
                    <dd class="cd5">{{bstextdata.remarks}}</dd>
                  </dl>
                </div>
                <div class="bstext-cent">
                  <div class="bs-txt">
                    <p class="p1">标书领取开放时间为工作日的9:00至17:00;若公司名称变更请重新注册后用新公司名称再进行领取</p>
                    <p class="p2" v-if="user_id!=''&&newtime=='2'">
                      <el-button type="primary" round @click="postbstextdata">立即申请领取</el-button> <span
                        v-if="multipleSelection.length==0">(请先勾选需要领取的分包)</span>
                    </p>
                    <p class="p2" v-if="user_id!=''&&newtime=='1'">
                      <el-button type="primary" round  disabled>暂停申请领取</el-button> <span
                        v-if="multipleSelection.length==0">(不在领取标书时间范围内)</span>
                    </p>
                    <p class="p2" v-if="user_id==''">
                      <el-button type="primary" round @click="dialogVisible = true">立即登录</el-button>
                    </p>
                  </div>
                  <template>
                    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                      @selection-change="handleSelectionChange">
                      <el-table-column type="selection" width="55">
                      </el-table-column>

                      <el-table-column label="序号" width="120">
                        <template slot-scope="scope">{{ scope.row.number }}</template>
                      </el-table-column>
                      <el-table-column prop="sub_id" label="分包号" width="120">
                      </el-table-column>
                      <el-table-column prop="name" label="项目分包名称" show-overflow-tooltip>
                      </el-table-column>
                    </el-table>

                  </template>
                </div>
              </div>
              <div class="bstext2" v-if="bstype==3">
                <el-divider>领取标书信息</el-divider>
                <dl class="dl2">
                  <dt>领取号:</dt>
                  <dd>{{orderdata.order_sn}}</dd>
                  <dt>信息服务费:</dt>
                  <dd>300 元</dd>
                  <dt>申请状态:</dt>
                  <dd>代付款</dd>
                </dl>
                <dl class="dl3">
                  <dt class="dt1">项目编号</dt>
                  <dt class="dt2">项目名称</dt>
                  <dt class="dt1">项目分包</dt>
                  <dt class="dt2">项目分包名称</dt>
                </dl>
                <dl class="dl4" v-for="( subdata,index) in orderdata.sub" :key="index + '-only'">
                  <dd class="dt1">{{orderdata.documents.project_sn}}</dd>
                  <dd class="dt2">{{orderdata.documents.project_name}}</dd>
                  <dd class="dt1">{{subdata.documents_sub_id}}</dd>
                  <dd class="dt2">{{subdata.name}}</dd>
                </dl>

                <el-divider>选择经办人</el-divider>
                <dl class="dl5">
                  <dt class="dt1">选择编号</dt>
                  <dt class="dt2">经办人姓名</dt>
                  <dt class="dt2">经办人电话</dt>
                  <dt class="dt2">邮箱</dt>
                  <dt class="dt3">邮寄地址</dt>
                  <dt class="dt2">岗位</dt>
                </dl>
                <dl class="dl6" v-for="(andlerdata,index) in orderdata.andler" :key="index">
                  <dt class="dt1">
                    <el-radio v-model="radio" :label="andlerdata.id"></el-radio>
                  </dt>
                  <dt class="dt2">{{andlerdata.full_name}}</dt>
                  <dt class="dt2">{{andlerdata.mobile}}</dt>
                  <dt class="dt2">{{andlerdata.email}}</dt>
                  <dt class="dt3">{{andlerdata.address}}</dt>
                  <dt class="dt2">{{andlerdata.position}}</dt>
                </dl>

                <el-divider>
                  <el-button type="primary" round @click="postorderpay">确认领取</el-button>
                  <el-button round @click="postordercancel">取消领取</el-button>
                </el-divider>
              </div>

            </el-tab-pane>
            <el-tab-pane label="政策采购" name="second">
              <p class="bsxt-p"><span class="span1">采购编号</span><span class="span2">项目名称</span><span
                  class="span3">招标文件领取日期</span></p>
              <ul class="bsxt-ul">
                <li v-for="(bslistdata,index) in bslistdata1" :key="index">
                  <span class="span1">{{bslistdata.project_sn}}</span>
                  <span class="span2" @click="getbstext(bslistdata.documents_id)">{{bslistdata.project_name}}</span>
                  <span class="span3">{{bslistdata.receive}}</span>
                </li>
              </ul>
              <div class="block">
                <el-pagination layout="prev, pager, next" :page-size="15" :total="total1"  @current-change="handleSizeChange1">
                </el-pagination>
              </div>

            </el-tab-pane>
            <el-tab-pane label="工程采购" name="third">
              <p class="bsxt-p"><span class="span1">采购编号</span><span class="span2">项目名称</span><span
                  class="span3">招标文件领取日期</span></p>
              <ul class="bsxt-ul">
                <li v-for="(bslistdata,index) in bslistdata2" :key="index">
                  <span class="span1">{{bslistdata.project_sn}}</span>
                  <span class="span2" @click="getbstext(bslistdata.documents_id)">{{bslistdata.project_name}}</span>
                  <span class="span3">{{bslistdata.receive}}</span>
                </li>
              </ul>
              <div class="block">
                <el-pagination layout="prev, pager, next"  :page-size="15" :total="total2"  @current-change="handleSizeChange2">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="企业招标" name="fourth">
              <p class="bsxt-p"><span class="span1">采购编号</span><span class="span2">项目名称</span><span
                  class="span3">招标文件领取日期</span></p>
              <ul class="bsxt-ul">
                <li v-for="(bslistdata,index) in bslistdata3" :key="index">
                  <span class="span1">{{bslistdata.project_sn}}</span>
                  <span class="span2" @click="getbstext(bslistdata.documents_id)">{{bslistdata.project_name}}</span>
                  <span class="span3">{{bslistdata.receive}}</span>
                </li>
              </ul>
              <div class="block">
                <el-pagination layout="prev, pager, next" :page-size="15" :total="total3"  @current-change="handleSizeChange3">
                </el-pagination>
              </div>

            </el-tab-pane>
          </el-tabs>
        </template>

      </div>
    </div>
    <!--content END-->
    <!--footer-->
    <div class="bottom">
      <div class="bot-left">
        <p class="p1">联系广智华荣</p>
        <p>电子邮箱：406223221@qq.com</p>
        <p>总机：028-61894045</p>
        <p>领取标书开放时间为工作日的9:00至17:00 </p>
        <p>公司地址：四川省成都市金牛区金周路595号</p>
      </div>
      <div class="bot-right">
        <p class="p1"> 微信订阅号：</p>
        <p class="p2"><img src="../../assets/images/wm3.png" alt=""></p>
      </div>
    </div>
    <div class="footer">
      OPYRIGHT (©) 2022 四川广智华荣工程项目咨询有限公司 备案号：<a href="https://beian.miit.gov.cn/"  target="_blank">蜀ICP备2021003450号</a>
    </div>

    <el-dialog title="登录" :close-on-click-modal="false" :visible.sync="dialogVisible" width="20%">
      <p class="lg-p">
        <el-input v-model="inputName" placeholder="请输入用户名"></el-input>
      </p>
      <p class="lg-p">
        <el-input placeholder="请输入密码" v-model="inputPassword" show-password></el-input>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postLogin">确定</el-button>
      </span>
    </el-dialog>

    </el-dialog>
    <el-dialog title="微信扫码支付" :visible.sync="dialogVisible3" width="40%">
      <p class="lg-p">
        <span class="sp1">商户订单号：{{paydata.order_sn}}</span>
        <span class="sp2">订单名称：{{paydata.name}}</span>
        <span class="sp1">付款金额：{{paydata.tender_service_fee}} 元</span>
        <span class="sp2">商品描述：{{paydata.project_name}} </span>
        <span class="sp3" id="qrcode" ref="qrCodeUrl"></span>
      </p>
      <p>
        若提示交易买家不匹配或无法支付,请到"我报名的项目-待付款项目"列表取消订单重新下单!或者更换成谷歌浏览器
        支付过程中请不要手动刷新或关闭支付跳转页面，
        以免购买信息更新不及时!
        支付完成后该页面会自动跳转，请不要提前关闭页面!
      </p>
      <p slot="footer" class="dialog-footer">
        <el-divider>
          <el-button type="primary" round @click="gouser()">完成交易</el-button>
        </el-divider>
      </p>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import http from '../../http.js';
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        visible: false,
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        activeName: 'first',
        activeName2: 'negg',
        activeName3: 'zcfg',
        input: "",
        checked: false,
        inputName: "",
        inputPassword: "",
        regnumber: 0,
        yhchecked: true,
        user_name: "",
        user_id: '',
        imageUrl: '',
        ruleForm: {
          username: '',
          password: '',
          checkPass: ''
        },
        newtime:2,
        formInline: {
          type: '',
          name: '',
          reg_address: '',
          company_type: '',
          taxpayer_id: '',
          business_scale: '',
          legal_phone: '',
          reg_capital: '',
          cm_linked_man: '',
          cm_linked_man_phone: '',
          estab_date: '',
          bank_number: '',
          company_tel: '',
          bank_account: '',
          billing_address: '',
          legal_repre: '',
          certificate_type: '',
          image_three: '',
          image_five: '',
        },
        radio: "",
        bslistdata: "",
        bslistdata1: "",
        bslistdata2: "",
        bslistdata3: "",
        documents_id: "",
        bstextdata: "",
        bstype: "3",
        tableData: [],
        multipleSelection: [],
        wechatkey: "",
        order_id: "",
        andler: "",
        orderdata: "",
        paydata: "",
        total1:1,
        total2:1,
        total3:1,
        total:1,
        page1:1,
        page2:1,
        page3:1,
        page:1,
      }
    },
    mounted: function() {
      this.getbslist(0,1);
      this.getbslist(1,1);
      this.getbslist(2,1);
      this.getbslist(3,1);
      var user_id = sessionStorage.getItem("user_id");
      if (user_id != undefined) {
        this.user_id = sessionStorage.getItem("user_id");
        this.user_name =sessionStorage.getItem("user_name");
      }

    },
    methods: {

      handleClose(done) {
        done();
      },
      /*选择标号*/
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection);
      },
      getnewtime(val) {
        console.log(333)
        console.log(val)
        var val2;
        val2 = val.replace(/-/g, "/");
        val2 = new Date(val2);
        console.log(444)
        var myDate = new Date();
        var now = myDate.valueOf();
        var time = new Date(val2).valueOf();
        console.log(555);
        console.log(now);
        console.log(time);
        if (now > time) {
          this.newtime = 2;
          console.log(888)
          console.log(this.newtime)
        } else {
          this.newtime = 1;
          console.log(999)
          console.log(this.newtime)
        }

      },
      getnewtime2(val) {
        console.log(333)
        console.log(val)
        var val2;
        val2 = val.replace(/-/g, "/");
        val2 = new Date(val2);
        console.log(444)
        var myDate = new Date();
        var now = myDate.valueOf();
        var time = new Date(val2).valueOf();
        console.log(555);
        console.log(now);
        console.log(time);
        if (now > time) {
          this.newtime = 1;
          console.log(888)
          console.log(this.newtime)
        } else {

          console.log(999)
          console.log(this.newtime)
        }

      },
      /*提交订单支付*/
      postorderpay() {
        var that = this;
        if (this.radio == '') {
          this.$message.error("请选择经办人");
          return;
        }
        this.dialogVisible3 == true;
        var parameter = {
          order_id: this.order_id,
          handler_id: this.radio,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/submit', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            this.dialogVisible3 = true;
            console.log(res.data.result);
            that.paydata = res.data.result;
            setTimeout(function() {
              that.creatQrCode(res.data.result.qrcode);
            }, 100);

          }
        }).catch(e => {
          //..
        })
      },


      /*提交取消订单*/
      postordercancel() {
        var that = this;
        var parameter = {
          order_id: this.order_id,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/cancel', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(2222);
            console.log(res.data.result);
            this.$message.success("取消成功");
            setTimeout(function() {
              that.$router.go(0);
            }, 1000);

          }
        }).catch(e => {
          //..
        })
      },


      /*提交标书订单*/
      postbsOrderdata() {
        var that = this;
        var sub_id = ''
        var parameter = {
          order_id: this.order_id,
          sub_id: sub_id,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/details', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            that.orderdata = res.data.result;
            console.log(res.data.result);

          }
        }).catch(e => {
          //..
        })


      },

      /*提交获取二维码*/
      creatQrCode(i) {
        const codeHtml = document.getElementById("qrcode");
        codeHtml.innerHTML = "";
        let a = new QRCode(this.$refs.qrCodeUrl, {
          text: i, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: "black", //#000000为黑色
          colorLight: "white",
        });
        console.log(i);

      },

      /*提交标书*/
      postbstextdata() {
        var that = this;
        var sub_id = ''
        if (this.multipleSelection.length != 0) {
          for (var i = 0; i < that.multipleSelection.length; i++) {
            if (that.multipleSelection[i].status == 1) {
              this.$message.error('请选择未曾投标的分包');
              return;
            } else {
              sub_id = sub_id + that.multipleSelection[i].sub_id + ","
            }
          }
          sub_id = sub_id.substr(0, sub_id.length - 1);

        } else {
          this.$message.error('请先勾选分包');
          return;
        }
        var parameter = {
          documents_id: sessionStorage.getItem("documents_id"),
          sub_id: sub_id,
          wechatkey: sessionStorage.getItem("key"),
        };
        http.post(this.conf.base_url + '/api/order/first', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
            return;
          } else {
            console.log(res.data.result);
            this.bstype = 3;
            this.order_id = res.data.result;
            that.postbsOrderdata();
          }
        }).catch(e => {
          //..
        })


      },
      /*标书跳转*/
      getbstext(i) {
        sessionStorage.setItem("documents_id", i);
        this.documents_id = i;
        this.getbstextdata();
      },

      /*标书跳转*/
      getbstextdata() {
        var that = this;
        console.log(1111);
        var parameter = {
          id: this.documents_id
        };
        if (this.user_id != '') {
          var parameter = {
            id: this.documents_id,
            user_id: this.user_id
          };
        }
        console.log(1111);
        console.log(this.user_id);
        console.log(parameter);
        console.log(parameter);
        http.post(this.conf.base_url + '/api/documents/details', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            this.bstextdata = res.data.result;
            this.activeName = 'first',
              this.bstype = 2;
            this.tableData = res.data.result.sub;
            this.getnewtime(res.data.result.receive_start_at);
            this.getnewtime2(res.data.result.receive_end_at);
            for (var i = 0; i < that.tableData.length; i++) {
              if (that.tableData[i].status == 1) {
                that.tableData[i].name = that.tableData[i].name + "(该分包已投标)"
              }
            }
          }
        }).catch(e => {
          //..
        })


      },
      handleSizeChange1(val){
        console.log(11)
        this.page1=val;
        console.log(this.page1);
         this.getbslist(1,val);
      },
      handleSizeChange2(val){
        console.log(22)
        this.page2=val;
        console.log(this.page2);
        this.getbslist(2,val);
      },
      handleSizeChange3(val){
        console.log(33)
        this.page3=val;
        console.log(this.page3);
        this.getbslist(3,val);
      },
      handleSizeChange(val){
        console.log(213)
        this.page=val;
         this.getbslist(0,val);
        console.log(this.page)
      },

      getbslist(i,a) {
        var that = this;
        this.bstype = "1";
        var parameter = {}
        if (i == 0) {
          var parameter = {
            page:a
          }
        } else if (i == 1) {
          var parameter = {
            type: 1,
             page:a
          }
        } else if (i == 2) {
          var parameter = {
            type: 2,
             page:a
          }
        } else if (i == 3) {
          var parameter = {
            type: 3,
             page:a
          }
        }
        http.post(this.conf.base_url + '/api/documents/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            if (i == 0) {
              this.bslistdata = res.data.result.list;
              this.total=res.data.result.total;
              console.log(that.bslistdata);
            }
            if (i == 1) {
              this.bslistdata1 = res.data.result.list;
             this.total1=res.data.result.total;
               console.log("政策");
              console.log(that.bslistdata1);
                console.log( this.total1);
            }
            if (i == 2) {
              this.bslistdata2 = res.data.result.list;
              this.total2=res.data.result.total;
            }
            if (i == 3) {
              this.total3=res.data.result.total
              this.bslistdata3 = res.data.result.list;
            }
          }
        }).catch(e => {
          //..
        })
      },


      /*注册步骤*/
      postregtw() {
        this.$message.error('请先填写对应数据');
        this.regnumber = 3;
      },
      /*注册第一步提交*/
      postregone() {
        var that = this;
        var parameter = {
          user_name: this.ruleForm.username,
          password: this.ruleForm.password,
          a_password: this.ruleForm.checkPass,
        };
        if (this.ruleForm.password != this.ruleForm.checkPass) {
          this.$message.error('两次密码不一致');
          return;
        }
        http.post(this.conf.base_url + '/api/login/account', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data.result);
            this.regnumber = 2;
          }
        }).catch(e => {
          //..
        })
      },

      /*图片上传*/
      handleAvatarSuccess(res, file) {
        this.formInline.image_five = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      /*登录*/
      postLogin() {
        console.log(this.conf.base_url);

        var that = this;
        var parameter = {
          user_name: this.inputName,
          password: this.inputPassword
        }
        http.post(this.conf.base_url + '/api/login/login', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data);
            sessionStorage.setItem("key", res.data.result.key);
            sessionStorage.setItem("user_id", res.data.result.user_id);
            sessionStorage.setItem("user_name", res.data.result.user_name);
            that.user_name = res.data.result.user_name;
           that.$router.go(0);

          }
        }).catch(e => {
          //..
        })
      },
      gologinout() {
        sessionStorage.clear();
        this.$router.go(0);
      },

      handleClick(tab, event) {
        this.bstype = 1;
        console.log(333333333);
      },

      goHome: function() {
        this.$router.push({
          path: '/index/'
        });
      },
      gogsdt: function() {
        this.$router.push({
          path: '/gsdt/'
        });
      },
      gojlyd: function() {
        this.$router.push({
          path: '/jlyd/'
        });
      },
      gokffw: function() {
        this.$router.push({
          path: '/kffw/'
        });
      },
      goqyjj: function() {
        this.$router.push({
          path: '/qyjj/'
        });
      },
      goqyxx: function() {
        this.$router.push({
          path: '/qyxx/'
        });
      },
      gorczp: function() {
        this.$router.push({
          path: '/rczp/'
        });
      },
      gozbxx: function() {
        this.$router.push({
          path: '/zbxx/'
        });
      },
      gobsxt: function() {
        this.$router.go(0);
      },
      gonewstxt: function() {
        this.$router.push({
          path: '/newstxt/'
        });
      },
      gouser: function() {
        this.$router.push({
          path: '/user/'
        });
      },
      goreg: function() {
        this.$router.push({
          path: '/reg/'
        });
      },


    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bsxt/bsxt.vue